import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/attach/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/attach/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/attach/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/attach/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/attach/submit', params,options);

export const getAttachByMainIdList = (params, options) =>
  request.get('/api/v4ward/attach/getAttachByMainIdList', Object.assign({}, options, { params }));
